/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TextSnippetVisibilityEnum = {
    Personal: 'PERSONAL',
    Practice: 'PRACTICE',
    Global: 'GLOBAL'
} as const;
export type TextSnippetVisibilityEnum = typeof TextSnippetVisibilityEnum[keyof typeof TextSnippetVisibilityEnum];

